const timezoneToCountries: { [key: string]: string[] } = {
  "America/New_York": ["US"],
  "America/Chicago": ["US"],
  "America/Denver": ["US"],
  "America/Los_Angeles": ["US"],
  "America/Phoenix": ["US"],
  "America/Anchorage": ["US"],
  "America/Honolulu": ["US"],
  "America/Toronto": ["CA"],
  "America/Vancouver": ["CA"],
  "America/Montreal": ["CA"],
  "America/Mexico_City": ["MX"],
  "America/Cancun": ["MX"],
  "America/Sao_Paulo": ["BR"],
  "America/Argentina/Buenos_Aires": ["AR"],
  "America/Bogota": ["CO"],
  "America/Lima": ["PE"],
  "America/Santiago": ["CL"],
  "America/Caracas": ["VE"],

  "Europe/London": ["GB"],
  "Europe/Dublin": ["IE"],
  "Europe/Paris": ["FR"],
  "Europe/Berlin": ["DE"],
  "Europe/Rome": ["IT"],
  "Europe/Madrid": ["ES"],
  "Europe/Amsterdam": ["NL"],
  "Europe/Brussels": ["BE"],
  "Europe/Zurich": ["CH"],
  "Europe/Vienna": ["AT"],
  "Europe/Stockholm": ["SE"],
  "Europe/Oslo": ["NO"],
  "Europe/Copenhagen": ["DK"],
  "Europe/Helsinki": ["FI"],
  "Europe/Warsaw": ["PL"],
  "Europe/Prague": ["CZ"],
  "Europe/Budapest": ["HU"],
  "Europe/Bucharest": ["RO"],
  "Europe/Athens": ["GR"],
  "Europe/Moscow": ["RU"],
  "Europe/Kiev": ["UA"],
  "Europe/Istanbul": ["TR"],

  "Asia/Tokyo": ["JP"],
  "Asia/Shanghai": ["CN"],
  "Asia/Hong_Kong": ["HK"],
  "Asia/Singapore": ["SG"],
  "Asia/Seoul": ["KR"],
  "Asia/Taipei": ["TW"],
  "Asia/Bangkok": ["TH"],
  "Asia/Jakarta": ["ID"],
  "Asia/Manila": ["PH"],
  "Asia/Kuala_Lumpur": ["MY"],
  "Asia/Dubai": ["AE"],
  "Asia/Riyadh": ["SA"],
  "Asia/Tehran": ["IR"],
  "Asia/Karachi": ["PK"],
  "Asia/Kolkata": ["IN"],
  "Asia/Dhaka": ["BD"],
  "Asia/Colombo": ["LK"],

  "Australia/Sydney": ["AU"],
  "Australia/Melbourne": ["AU"],
  "Australia/Perth": ["AU"],
  "Australia/Brisbane": ["AU"],
  "Australia/Adelaide": ["AU"],
  "Pacific/Auckland": ["NZ"],

  "Africa/Cairo": ["EG"],
  "Africa/Lagos": ["NG"],
  "Africa/Johannesburg": ["ZA"],
  "Africa/Nairobi": ["KE"],
  "Africa/Casablanca": ["MA"],
};

const languageToCountries: { [key: string]: string[] } = {
  en: ["US", "GB", "CA", "AU", "NZ", "IE"],
  es: ["ES", "MX", "AR", "CO", "PE", "CL", "VE"],
  fr: ["FR", "CA", "BE", "CH"],
  de: ["DE", "AT", "CH"],
  it: ["IT", "CH"],
  pt: ["BR", "PT"],
  ru: ["RU", "UA", "BY"],
  zh: ["CN", "TW", "HK", "SG"],
  ja: ["JP"],
  ko: ["KR"],
  ar: ["SA", "AE", "EG", "MA"],
  hi: ["IN"],
  th: ["TH"],
  vi: ["VN"],
  id: ["ID"],
  ms: ["MY"],
  tl: ["PH"],
  tr: ["TR"],
  nl: ["NL", "BE"],
  sv: ["SE"],
  no: ["NO"],
  da: ["DK"],
  fi: ["FI"],
  pl: ["PL"],
  cs: ["CZ"],
  hu: ["HU"],
  ro: ["RO"],
  el: ["GR"],
};

export interface CountryDetectionResult {
  countryCode: string;
  confidence: "high" | "medium" | "low";
  method:
    | "locale_timezone_match"
    | "language_timezone_intersection"
    | "timezone_priority"
    | "locale_fallback"
    | "language_fallback";
  debugInfo?: {
    locale?: string;
    languageCode?: string;
    localeCountryCode?: string;
    timezone?: string;
    timezoneCountries?: string[];
    languageCountries?: string[];
    error?: string;
  };
}

export class CountryDetectionUtils {
  private static validCountryCodes = [
    "AF",
    "AX",
    "AL",
    "DZ",
    "AS",
    "AD",
    "AO",
    "AI",
    "AQ",
    "AG",
    "AR",
    "AM",
    "AW",
    "AU",
    "AT",
    "AZ",
    "BS",
    "BH",
    "BD",
    "BB",
    "BY",
    "BE",
    "BZ",
    "BJ",
    "BM",
    "BT",
    "BO",
    "BQ",
    "BA",
    "BW",
    "BV",
    "BR",
    "IO",
    "BN",
    "BG",
    "BF",
    "BI",
    "CV",
    "KH",
    "CM",
    "CA",
    "KY",
    "CF",
    "TD",
    "CL",
    "CN",
    "CX",
    "CC",
    "CO",
    "KM",
    "CG",
    "CD",
    "CK",
    "CR",
    "CI",
    "HR",
    "CU",
    "CW",
    "CY",
    "CZ",
    "DK",
    "DJ",
    "DM",
    "DO",
    "EC",
    "EG",
    "SV",
    "GQ",
    "ER",
    "EE",
    "SZ",
    "ET",
    "FK",
    "FO",
    "FJ",
    "FI",
    "FR",
    "GF",
    "PF",
    "TF",
    "GA",
    "GM",
    "GE",
    "DE",
    "GH",
    "GI",
    "GR",
    "GL",
    "GD",
    "GP",
    "GU",
    "GT",
    "GG",
    "GN",
    "GW",
    "GY",
    "HT",
    "HM",
    "VA",
    "HN",
    "HK",
    "HU",
    "IS",
    "IN",
    "ID",
    "IR",
    "IQ",
    "IE",
    "IM",
    "IL",
    "IT",
    "JM",
    "JP",
    "JE",
    "JO",
    "KZ",
    "KE",
    "KI",
    "KP",
    "KR",
    "KW",
    "KG",
    "LA",
    "LV",
    "LB",
    "LS",
    "LR",
    "LY",
    "LI",
    "LT",
    "LU",
    "MO",
    "MG",
    "MW",
    "MY",
    "MV",
    "ML",
    "MT",
    "MH",
    "MQ",
    "MR",
    "MU",
    "YT",
    "MX",
    "FM",
    "MD",
    "MC",
    "MN",
    "ME",
    "MS",
    "MA",
    "MZ",
    "MM",
    "NA",
    "NR",
    "NP",
    "NL",
    "NC",
    "NZ",
    "NI",
    "NE",
    "NG",
    "NU",
    "NF",
    "MK",
    "MP",
    "NO",
    "OM",
    "PK",
    "PW",
    "PS",
    "PA",
    "PG",
    "PY",
    "PE",
    "PH",
    "PN",
    "PL",
    "PT",
    "PR",
    "QA",
    "RE",
    "RO",
    "RU",
    "RW",
    "BL",
    "SH",
    "KN",
    "LC",
    "MF",
    "PM",
    "VC",
    "WS",
    "SM",
    "ST",
    "SA",
    "SN",
    "RS",
    "SC",
    "SL",
    "SG",
    "SX",
    "SK",
    "SI",
    "SB",
    "SO",
    "ZA",
    "GS",
    "SS",
    "ES",
    "LK",
    "SD",
    "SR",
    "SJ",
    "SE",
    "CH",
    "SY",
    "TW",
    "TJ",
    "TZ",
    "TH",
    "TL",
    "TG",
    "TK",
    "TO",
    "TT",
    "TN",
    "TR",
    "TM",
    "TC",
    "TV",
    "UG",
    "UA",
    "AE",
    "GB",
    "US",
    "UM",
    "UY",
    "UZ",
    "VU",
    "VE",
    "VN",
    "VG",
    "VI",
    "WF",
    "EH",
    "YE",
    "ZM",
    "ZW",
  ];

  static detectCountry(
    includeDebugInfo: boolean = false
  ): CountryDetectionResult {
    try {
      const locale = navigator.language || (navigator as any).userLanguage;
      const languageCode = locale ? locale.split("-")[0].toLowerCase() : "";
      const localeCountryCode =
        locale && locale.includes("-")
          ? locale.split("-")[1]?.toUpperCase()
          : "";

      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const timezoneCountries = timezoneToCountries[timezone] || [];
      const languageCountries = languageToCountries[languageCode] || [];

      const debugInfo = includeDebugInfo
        ? {
            locale,
            languageCode,
            localeCountryCode,
            timezone,
            timezoneCountries,
            languageCountries,
          }
        : undefined;

      if (
        localeCountryCode &&
        this.validCountryCodes.includes(localeCountryCode)
      ) {
        if (timezoneCountries.includes(localeCountryCode)) {
          return {
            countryCode: localeCountryCode,
            confidence: "high",
            method: "locale_timezone_match",
            debugInfo,
          };
        }
      }

      const intersection = timezoneCountries.filter(
        (country) =>
          languageCountries.includes(country) &&
          this.validCountryCodes.includes(country)
      );

      if (intersection.length > 0) {
        return {
          countryCode: intersection[0],
          confidence: "high",
          method: "language_timezone_intersection",
          debugInfo,
        };
      }

      if (timezoneCountries.length > 0) {
        const validTimezoneCountry = timezoneCountries.find((country) =>
          this.validCountryCodes.includes(country)
        );
        if (validTimezoneCountry) {
          return {
            countryCode: validTimezoneCountry,
            confidence: "medium",
            method: "timezone_priority",
            debugInfo,
          };
        }
      }

      if (
        localeCountryCode &&
        this.validCountryCodes.includes(localeCountryCode)
      ) {
        return {
          countryCode: localeCountryCode,
          confidence: "medium",
          method: "locale_fallback",
          debugInfo,
        };
      }

      if (languageCountries.length > 0) {
        const validLanguageCountry = languageCountries.find((country) =>
          this.validCountryCodes.includes(country)
        );
        if (validLanguageCountry) {
          return {
            countryCode: validLanguageCountry,
            confidence: "low",
            method: "language_fallback",
            debugInfo,
          };
        }
      }

      return {
        countryCode: "",
        confidence: "low",
        method: "language_fallback",
        debugInfo,
      };
    } catch (error: any) {
      console.log("SUM: Country detection error:", error);
      return {
        countryCode: "",
        confidence: "low",
        method: "language_fallback",
        debugInfo: includeDebugInfo ? { error: error.message } : undefined,
      };
    }
  }

  static getCountryCode(): string {
    return this.detectCountry().countryCode;
  }

  static isValidCountryCode(countryCode: string): boolean {
    return this.validCountryCodes.includes(countryCode.toUpperCase());
  }

  static getValidCountryCodes(): string[] {
    return [...this.validCountryCodes];
  }

  static addTimezoneMapping(timezone: string, countries: string[]): void {
    timezoneToCountries[timezone] = countries;
  }

  static addLanguageMapping(language: string, countries: string[]): void {
    languageToCountries[language] = countries;
  }
}

export default CountryDetectionUtils;

export const getBrowserCountryCode = (): string => {
  return CountryDetectionUtils.getCountryCode();
};
